<template>
  <div>
    <!-- Post -->
    <article
      v-for="page in pages.filter((page) => page.path == path)"
      :key="page.id"
      class="post"
    >
      <vue-headful
        :title="page.meta_title"
        :description="page.meta_description"
      />
      <div v-if="page.title != 'Home'" class="title" data-aos="fade">
        <h1 class="title" v-html="page.title"></h1>
      </div>
      
      <div data-aos="fade">
        <div v-html="page.content" class="mb-6 content"></div>
      </div>
      
      <h2 class="subtitle is-size-3 mt-6" v-if="childPages.length > 0 && products.length > 0"  data-aos="fade">{{$t('page.Series') }}</h2>

      <div
        class="tile is-ancestor category"
        v-for="row in rows(childPages)"
        :key="row.id"
      >
        <div class="tile is-parent is-3" v-for="child in row" :key="child.id" data-aos="fade">
          <article class="tile is-child box has-text-centered thumbnail">
            <router-link :to="'/' + $i18n.locale + '/' + child.path">
              <h4 class="title is-4" v-html="child.title"></h4>
              <figure
                class="image"
              >
                <img :src="child.thumbnail" />
              </figure>
            </router-link>
          </article>
        </div>
      </div>

      <h2 class="subtitle is-size-3 mt-6" v-if="products.length > 0" data-aos="fade">{{$t('page.Artworks') }}</h2>

      <div
        class="tile is-ancestor artwork"
        v-for="row in rows(products)"
        :key="row.id"
      >
        <div class="tile is-parent is-3" v-for="child in row" :key="child.id" data-aos="fade">
          <article class="tile is-child box has-text-centered thumbnail">
            <router-link :to="{ name: 'Artwork', params: { id: child.slug } }">
              <h4 class="title is-4" v-html="child.name"></h4>
              <figure
                class="image"
              >
                <img :src="child.medium" />
              </figure>
            </router-link>
          </article>
        </div>
      </div>
    </article>
  </div>
</template>

<script>
import axios from "axios";
import Vue from 'vue';
import ContactForm from "@/components/ContactForm";

export default {
  name: "Page",
  props: {
    path: {
      type: String,
      default: "home",
    },
    pages: Array,
  },
  data() {
    return {
      childPages: [],
      products: [],
      slug: ""
    };
  },
  // components: { ContactForm },
  methods: {
    rows(obj) {
      var numberOfColumns = 4;
      var rows = [];
      var count = 0;
      var row = [];
      for (var i in obj) {
        count++;
        row.push(obj[i]);
        if (count % numberOfColumns == 0 || i == obj.length - 1) {
          rows.push(row);
          row = [];
        }
      }
      return rows;
    },
    getChildPages() {
      var parent = this.pages.filter((page) => page.path == this.path)[0];
      this.childPages = this.pages
        .filter((page) => page.parent == parent.id);
    },
    async getProducts() {
      this.products = [];
      let response = await axios.get(
        process.env.VUE_APP_API_URL_EN +
          "wp-json/blackdigital/v1/products/" +
          this.slug
      );

      this.products = response.data;
    },
    addForms() {
      var contactForm = document.querySelector("div[ref='contactForm']");
      if (contactForm) {
        var ComponentClass = Vue.extend(ContactForm)
        const i18n = this.$i18n
        var instance = new ComponentClass({i18n})
        instance.$mount("div[ref='contactForm']"); // pass nothing
        // contactForm.appendChild(instance.$el);
      }
    }
  },
  mounted() {
    // used when moving from one route back to this one
    var parent = this.pages.filter((page) => page.path == this.path)[0];
      if (parent) {
        this.slug = parent.slug;
        this.getChildPages();
        this.getProducts();
      }
    this.$nextTick(()=>{
          this.addForms();
        })
  },
  watch: {
    // used when changing the dynamic url parameter
    $route(from, to) {// eslint-disable-line no-unused-vars
      var parent = this.pages.filter((page) => page.path == this.path)[0];
      if (parent) {
        this.slug = parent.slug;
        this.getChildPages();
        this.getProducts();
      }
      this.$nextTick(()=>{
          this.addForms();
        })
    },
    pages(val) {
      var parent = this.pages.filter((page) => page.path == this.path)[0];
      if (!parent) {
        this.$router.push({ name: "PageNotFound" });
      } else {
        this.slug = parent.slug;
        this.getChildPages();
        this.getProducts();
      }
      
      if(val){
        this.$nextTick(()=>{
          this.addForms();
        })
      }

    },
  },
};
</script>